
import {Vue, Component, Prop} from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component
export default class RelayClosed extends Vue {
    @Prop({default: null})
    public closures: any;

    @Prop({default: null})
    public messagePath: string;

    @Getter private isMobile: boolean;

    get currentClosure(): any {
        if (!this.closures?.items?.length) {
            // If the relay has no closures saved, it's open
            return false;
        } else {
            // Else, check if we are in a period of closure
            return this.closures.items.find((closure) => new Date() > new Date(closure?.startDate)
                && new Date() < new Date(closure?.endDate));
        }
    }

}
